"use client"

import { useTr } from "../lib/use-tr"
import dynamic from "next/dynamic"

import { CASE_STUDIES_T } from "./translations"
import type { Lead } from "@/nango/types/apps.autoleads/autoleads/AutoLeads"

function MapLoading() {
  const tr = useTr(CASE_STUDIES_T)
  return (
    <div className="text-muted-foreground flex h-full min-h-120 items-center justify-center text-sm">
      {tr("loadingMap")}
    </div>
  )
}

const LeadsMap = dynamic(
  () => import("../logged-in/campaigns/[id]/leads-map"),
  {
    ssr: false,
    loading: () => <MapLoading />,
  },
)

export function CaseStudyMap({ leads }: { leads: Lead[] | undefined }) {
  return <LeadsMap leads={leads ?? []} className="p-2" />
}
